export enum FieldType {
  /**
   * 图片
   */
  IMAGE = "image",

  /**
   * 图片列表
   */
  IMAGE_LIST = "image_list",

  /**
   * 文本
   */
  TEXT = "text",

  /**
   * 时长
   */
  DURATION = "duration",

  /**
   * 数字
   */
  NUMBER = "number",

  /**
   * 货币
   * @default 保留两位小数
   */
  CURRENCY = "currency",

  /**
   * 数字货币 - 数据没有单位可用这个
   * @default 保留两位小数
   */
  NUMBER_CURRENCY = "number_currency",

  /**
   * 价格
   * `floorPrice` 和 `ceilingPrice` 不相等，表示价格区间
   */
  PRICE = "price",

  /**
   * 百分比
   * @default 保留两位小数
   */
  PERCENTAGE = "percentage",

  /**
   * 浮点数
   * @default 保留两位小数
   */
  FLOAT = "float",

  /**
   * 转化率
   * @default 保留两位小数
   */
  CONVERSION_RATE = "conversion_rate",
}
